import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useUsuario } from "../../../../context/UsuarioContext";

export default function DetalleUsuario() {
    const { usuarioSeleccionado, modalOpenDetalleUsuario, handleOpenDetalleUsuario } = useUsuario();

    return (
        <MeditocModal
            size="small"
            title="Detalle de usuario"
            open={modalOpenDetalleUsuario}
            setopen={handleOpenDetalleUsuario}
            okmessage="Cerrar detalle"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de usuario:" value={usuarioSeleccionado.iIdUsuario} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Usuario Meditoc:" value={usuarioSeleccionado.sUsuario} br />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre:" value={usuarioSeleccionado.sNombres} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Apellido paterno:" value={usuarioSeleccionado.sApellidoPaterno} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Apellido materno:" value={usuarioSeleccionado.sApellidoMaterno} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha de nacimiento:" value={usuarioSeleccionado.sFechaNacimiento} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Domicilio:" value={usuarioSeleccionado.sDomicilio} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Correo electrónico:" value={usuarioSeleccionado.sCorreo} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Teléfono:" value={usuarioSeleccionado.sTelefono} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Perfil:" value={usuarioSeleccionado.sPerfil} br />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Tipo de cuenta:" value={usuarioSeleccionado.sTipoCuenta} br />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
